import { createTheme, Theme } from "@mui/material/styles";

export const getTheme = (isDark: boolean): Theme => {
  if (!isDark) {
    // Restore original empty theme — no custom primary/background/text overrides.
    // MUI defaults are used (blue primary #1976d2, white paper, etc.)
    return createTheme({
      typography: {
        fontFamily: "Montserrat, sans-serif",
      },
    });
  }

  return createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#EC7C37",
      },
      background: {
        default: "#0f1117",
        paper: "#1a1d27",
      },
      text: {
        primary: "#e8eaf0",
        secondary: "#6b7280",
      },
      divider: "rgba(255,255,255,0.12)",
    },
    typography: {
      fontFamily: "Montserrat, sans-serif",
    },
  });
};

// Legacy default export — keeps any direct imports working
export default getTheme(false);
